/**
 * Sales Invoice Download Formatter.
 */
window.salesInvoiceDownloadFormatter = function(value, row) {
    let html = '';
    if (row.hash_name) {
        html += '<a href="/admin/sales/invoices/download/'+row.sales_invoice_id+'">';
        html += '<i class="fa fa-download"></i>';
        html += '</a>';
    }
    return html;
}
